import { render, staticRenderFns } from "./updateInfo.vue?vue&type=template&id=4da369be&"
import script from "./updateInfo.vue?vue&type=script&lang=js&"
export * from "./updateInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports